import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './SubscriptionCancelled.css'

/**
 * Cancellation page after user cancels Stripe Checkout
 * Shows message and options to retry or go back
 */
const SubscriptionCancelled = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('subscription')

  return (
    <div className="subscription-cancelled-page">
      <div className="cancelled-container">
        {/* Cancel Icon */}
        <div className="cancel-icon-wrapper">
          <div className="cancel-icon">
            <svg
              className="cancel-x"
              viewBox="0 0 52 52"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="cancel-circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                className="cancel-line cancel-line-1"
                fill="none"
                d="M16 16 l20 20"
              />
              <path
                className="cancel-line cancel-line-2"
                fill="none"
                d="M36 16 l-20 20"
              />
            </svg>
          </div>
        </div>

        {/* Cancel Message */}
        <div className="cancelled-content">
          <h1 className="cancelled-title">{t('cancelled.title')}</h1>
          <p className="cancelled-message">
            {t('cancelled.message')}
          </p>

          {/* Info Box */}
          <div className="info-box">
            <h3>{t('cancelled.whatToDo.title')}</h3>
            <ul className="options-list">
              <li>
                <span className="option-icon">💡</span>
                <span>{t('cancelled.whatToDo.options.reviewPlans')}</span>
              </li>
              <li>
                <span className="option-icon">💳</span>
                <span>{t('cancelled.whatToDo.options.tryLater')}</span>
              </li>
              <li>
                <span className="option-icon">📧</span>
                <span>{t('cancelled.whatToDo.options.contactUs')}</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="cancelled-actions">
            <button
              className="btn-primary"
              onClick={() => navigate('/subscription')}
            >
              {t('cancelled.buttons.backToPlans')}
            </button>
            <button
              className="btn-secondary"
              onClick={() => navigate('/dashboard')}
            >
              {t('cancelled.buttons.toDashboard')}
            </button>
          </div>

          {/* Help Text */}
          <p className="help-text">
            {t('cancelled.helpText')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionCancelled
